module.exports = __webpack_public_path__ + "static/img/118.f8451ac7.gif";